import React from "react";
import { Box } from "@mui/material";
import { MyHrProfilesRolesData } from "my-hr/components";

interface MyHrProfileRolesProps {
  contracts: Array<any>; // Replace 'any' with the actual contract type if available
}

export const MyHrProfileRoles: React.FC<MyHrProfileRolesProps> = ({
  contracts,
}) => {
  return (
    <Box>
      {contracts.map((contract, index) => (
        <Box key={`${contract?.code}-edit-form`}>
          <MyHrProfilesRolesData contract={contract} />
          {index < contracts.length - 1 && <Box height="16px" />}
        </Box>
      ))}
    </Box>
  );
};

export default MyHrProfileRoles;
